import React from 'react'
import { View } from 'react-native'
import { OverlayProvider, Tooltip as RNTooltip } from 'react-native-popper'

import styled, { useTheme } from 'styled-components/native'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { BodyTextSize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

export type TabIconWithTooltipProps = {
  icon: React.ReactNode
  tooltipText: string
  testID?: string
  isHovered?: boolean
}

const TooltipContent = styled.View<{ theme: ThemeType }>(({ theme: { spacing, colors } }) => ({
  backgroundColor: colors.backgroundTooltip,
  padding: `${spacing['8px']} ${spacing['12px']}`,
  borderRadius: '4px',
}))

export const TabIconWithTooltip: React.FC<TabIconWithTooltipProps> = ({
  icon,
  tooltipText,
  testID,
  isHovered = false,
}) => {
  const theme = useTheme() as ThemeType
  const { Content, Arrow } = RNTooltip
  const open = isHovered ?? false

  return (
    <OverlayProvider>
      <RNTooltip
        isOpen={open}
        on='hover'
        placement='bottom'
        offset={12}
        trigger={
          <View
            // @ts-ignore - web-only props
            tabIndex={-1}
            aria-hidden={true}
            accessible={false}
            importantForAccessibility='no'
          >
            {icon}
          </View>
        }
      >
        {/* Tooltip content */}
        <Content>
          <TooltipContent testID={tID(`${testID}-tooltip`)}>
            <BodyText size={BodyTextSize.SMALL} color={theme.colors.textInverse}>
              {tooltipText}
            </BodyText>
          </TooltipContent>
          <Arrow
            style={{
              backgroundColor: theme.colors.backgroundTooltip,
            }}
            height={8}
            width={8}
          />
        </Content>
      </RNTooltip>
    </OverlayProvider>
  )
}
